<template>
  <div>
    <Select v-model="yearName" style="width: 150px" @on-change="changeYear">
      <template v-for="item in yearList">
        <Option :value="item" :key="item">{{ item }}&nbsp;年度数据</Option>
      </template>
    </Select>
    <!-- <Dropdown @on-click="changeYear">
      <a href="javascript:void(0)">
        {{ yearName }}
        <Icon type="ios-arrow-down"></Icon>
      </a>
      <DropdownMenu slot="list">
        <template v-for="(item, index) in yearList">
          <DropdownItem :name="item" :key="index">{{ item }}</DropdownItem>
        </template>
      </DropdownMenu>
    </Dropdown> -->
  </div>
</template>

<script>
import { parseTime } from '@/utils/date.js';
import { createCompanyTime } from '@/utils/common';
export default {
  props: {
    createTime: {
      type: [String, Number],
      default: '',
    },
    yearTime: {
      type: [String, Number],
      default: '',
    },
  },
  watch: {
    createTime(val) {
      this.yearList = createCompanyTime(val, this.todayYear);
      console.log('this.yearList', this.yearList);
    },
    yearTime(val) {
      this.yearName = val;
    },
  },
  data() {
    return {
      yearName: '',
      todayYear: '', // 今年
      yearList: [],
    };
  },
  mounted() {
    // 获取当年
    this.todayYear = Number(parseTime(new Date(), '{y}'));
  },
  methods: {
    changeYear(n) {
      this.$emit('sendChangeTime', n);
    },
  },
};
</script>

<style></style>
